import React from 'react';
// Visa-Free Projection
const FourteenStepTemplate = ({ values }) => {
  const {
    client_name,
    conference_short_name,
    country_name,
    visa_free_guide_link,
    registration_link,
    your_name,
    contact_details,
  } = values;
  return (
    <div>
      <p>{client_name ? `Hi ${client_name}` : `Hi [Recipient's Name],`}</p>
      <p>
        We are delighted to inform you that{' '}
        <strong>
          {conference_short_name
            ? conference_short_name
            : `[Conference Short Name]`}
        </strong>{' '}
        offers <strong>visa-free entry</strong> for participants from{' '}
        <strong> {country_name ? country_name : `[Your Country]`}</strong>,
        allowing you to attend without the hassle of applying for a visa.
      </p>

      <p>
        To ensure a seamless travel experience, please refer to our guide for
        more details on the visa-free process:{' '}
        <strong>
          {visa_free_guide_link ? (
            <a
              href={visa_free_guide_link}
              target="_blank"
              rel="noopener noreferrer"
            >
              Visa-Free Guide
            </a>
          ) : (
            `[Link to Visa-Free Guide]`
          )}
        </strong>
        .
      </p>
      <p>
        This is your chance to:
        <br />✅ Attend a globally recognized conference without visa
        complications
        <br />✅ Network with leading experts and professionals from around the
        world
        <br />✅ Gain valuable insights and enhance your professional
        credentials
      </p>

      <p>
        {registration_link ? (
          <>
            <strong>👉 Register Now: </strong>
            <a
              href={registration_link}
              target="_blank"
              rel="noopener noreferrer"
            >
              Click Here
            </a>
          </>
        ) : ( 
          <strong>👉 Register Now: [Registration Link]</strong>
        )}
      </p>

      <p>
        If you have any questions or need assistance, feel free to reach out. We
        look forward to welcoming you to the conference!
      </p>
      <div>
        <strong>Best regards,</strong>
      </div>
      <div>{your_name ? your_name : '[Your Name]'}</div>
      <div>{contact_details ? contact_details : '[Contact details]'}</div>
    </div>
  );
};

export default FourteenStepTemplate;
